import { Helmet } from "react-helmet";

export default function OpenGraphSeoConfig() {
  const isProd = import.meta.env.VITE_PROD === "true";

  return isProd ? (
    <Helmet>
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Darvin" />
      <meta
        property="og:title"
        content="Darvin AI — No-Code Flutter Mobile App Builder from Text"
      />
      <meta
        property="og:description"
        content="Turn plain language into native Flutter Mobile Apps — no code needed. Darvin AI designs, builds & ships production-ready Android and iOS releases in minutes."
      />
      <meta property="og:url" content="https://darvin.dev/" />
      <meta property="og:locale" content="en_US" />
      <meta
        property="og:image"
        content="https://darvin.dev/assets/og-image.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://darvin.dev/assets/og-image.jpg"
      />
      <meta
        property="og:image:alt"
        content="Darvin AI — build Flutter apps from text"
      />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
    </Helmet>
  ) : null;
}
